import React, { useState } from "react";
import { db, storage } from "../../../firebase";
import { doc, updateDoc, arrayUnion, getDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import styles from "./PdfUploadForm.module.css";

const PdfUploadForm = ({ companyId, setPdfs, onClose }) => {
  // ✅ onClose 추가
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      setMessage("❌ 업로드할 PDF 파일을 선택하세요!");
      return;
    }

    setUploading(true);
    setMessage("⏳ PDF 업로드 중...");

    try {
      const storageRef = ref(storage, `pdfs/${companyId}/${file.name}`);
      await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(storageRef);

      console.log("✅ PDF 다운로드 URL:", downloadURL);

      // Firestore에 PDF URL 추가하기 전에 해당 문서가 있는지 확인
      const companyRef = doc(db, "companies", companyId);
      const docSnap = await getDoc(companyRef);

      if (!docSnap.exists()) {
        setMessage("❌ 회사 정보가 Firestore에 존재하지 않습니다.");
        setUploading(false);
        return;
      }

      // Firestore 문서 업데이트
      await updateDoc(companyRef, {
        pdfs: arrayUnion({ name: file.name, url: downloadURL }),
      });

      setMessage("✅ PDF 업로드 완료!");
      setPdfs((prev) => [...prev, { name: file.name, url: downloadURL }]);

      // ✅ 1. 업로드 성공 후 모달 자동 닫기
      setTimeout(() => {
        onClose();
      }, 1000); // 1초 후 모달 닫기

      setFile(null);
    } catch (error) {
      console.error("❌ PDF 업로드 오류:", error);
      setMessage(`❌ 오류 발생: ${error.message}`);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className={styles.container}>
      <h3>📄 PDF 업로드</h3>
      <form onSubmit={handleUpload} className={styles.form}>
        <input
          type="file"
          accept="application/pdf"
          onChange={handleFileChange}
        />
        <button type="submit" disabled={uploading}>
          {uploading ? "업로드 중..." : "업로드"}
        </button>
      </form>
      {message && <p className={styles.message}>{message}</p>}
    </div>
  );
};

export default PdfUploadForm;
